export default {
    orientations: ['horizontal', 'vertical']
};
